// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
    {
        title: '新增',
        icon: 'el-icon-circle-plus-outline',
    },
    {
        title: '修改',
        icon: 'el-icon-edit',
    },
    {
        title: '删除',
        icon: 'el-icon-delete',
    },
    {
        title: '查看',
        icon: 'el-icon-watch',
    },
    {
        title: '查询',
        icon: 'el-icon-Ssearch',
    },
    {
        title: '右滑',
        icon: 'el-icon-sort',
    },
    {
        title: '打印',
        icon: 'el-icon-printer',
    },
    {
        title: '导入',
        icon: 'el-icon-export',
    },
    {
        title: '关闭',
        icon: 'el-icon-close',
    },
    {
        title: '目录',
        icon: 'el-icon-document',
    },
    {
        title: '区域',
        icon: 'el-icon-s-promotion',
    },
    {
        title: '费用',
        icon: 'el-icon-charging',
    },
    {
        title: '价格',
        icon: 'el-icon-chargingPrice',
    },
    {
        title: '建筑',
        icon: 'el-icon-yqlb',
    },
    {
        title: '参数',
        icon: 'el-icon-tnzdsj',
    },
    {
        title: '稳定',
        icon: 'el-icon-xjwdy',
    },
    {
        title: '清热',
        icon: 'el-icon-jxdy',
    },
    {
        title: '药品',
        icon: 'el-icon-tlzt',
    },
    {
        title: '给药',
        icon: 'el-icon-quyaoput',
    },
    {
        title: '药时',
        icon: 'el-icon-qrxc',
    },
    {
        title: '单据',
        icon: 'el-icon-flxz',
    },
    {
        title: '挂号',
        icon: 'el-icon-ghlb',
    },
    {
        title: '收费',
        icon: 'el-icon-coin',
    },
    {
        title: '微信',
        icon: 'el-icon-weixin',
    },
    {
        title: '聚合',
        icon: 'el-icon-juhezhifu',
    },
    {
        title: '支付宝',
        icon: 'el-icon-zhifubao',
    },
    {
        title: '门诊',
        icon: 'el-icon-menzhen',
    },
    {
        title: '类别',
        icon: 'el-icon-bumenOpen'
    },
    {
        title: '西成药',
        icon: 'el-icon-xy',
    },
    {
        title: "中药",
        icon: 'el-icon-zy',
    },
    {
        title: '中草药',
        icon: 'el-icon-zhongcaoyao',
    },
    {
        title: '药典',
        icon: 'el-icon-ydml',
    },
    {
        title: "西药房",
        icon: 'el-icon-xyf',
    },
    {
        title: '中药房',
        icon: 'el-icon-zyf',
    },

    {
        title: '用户',
        icon: 'el-icon-users',
    },
    {
        title: '系统用户',
        icon: 'el-icon-userSystem',
    },
    {
        title: '导出',
        icon: 'el-icon-lszt',
    },
    {
        title: '角色',
        icon: 'el-icon-roles',
    },
    {
        title: '身份类别',
        icon: 'el-icon-idKinds',
    },
    {
        title: '业务类别',
        icon: 'el-icon-kinds'
    },
    {
        title: '下载完成',
        icon: 'el-icon-finishedFill',
    },

    {
        title: '账单',
        icon: 'el-icon-navicon-kcz'
    },
    {
        title: '上传',
        icon: 'el-icon-upload2',
    },
    {
        title: "下载",
        icon: 'el-icon-download',
    },
    {
        title: "完成",
        icon: 'el-icon-finished',
    },

    {
        title: "坐诊",
        icon: 'el-icon-zzgl',
    },
    {
        title: "档案",
        icon: 'el-icon-jkda',
    },

    {
        title: '工具',
        icon: 'el-icon-tsgj'
    },
    {
        title: '设置',
        icon: 'el-icon-s-tools',
    },

    {
        title: "电话",
        icon: 'el-icon-phone',
    },
    {
        title: "外呼",
        icon: 'el-icon-phone-outline',
    },
    {
        title: "三个点",
        icon: 'el-icon-more',
    },
    {
        title: "收藏",
        icon: 'el-icon-star-on',
    },
    {
        title: "notes",
        icon: 'el-icon-notebook-2',
    },
    {
        title: "加号",
        icon: 'el-icon-plus',
    },
    {
        title: "减号",
        icon: 'el-icon-minus',
    },
    {
        title: "圆圈√",
        icon: 'el-icon-circle-check',
    },
    {
        title: "圆圈×",
        icon: 'el-icon-circle-close',
    },
    {
        title: "采购",
        icon: 'el-icon-shopping-cart-2',
    },
    {
        title: "入库",
        icon: 'el-icon-s-platform',
    },
    {
        title: "退货",
        icon: 'el-icon-s-check',
    },
    {
        title: "库存",
        icon: 'el-icon-kuc',
    },
    {
        title: "相机",
        icon: 'el-icon-camera',
    },
    {
        title: "投影",
        icon: 'el-icon-video-camera',
    },
    {
        title: "铃铛",
        icon: 'el-icon-message-solid',
    },
    {
        title: "导航",
        icon: 'el-icon-s-promotion',
    },
    {
        title: "菜单",
        icon: 'el-icon-menu',
    },
    {
        title: "特权账号",
        icon: 'el-icon-yigongti',
    },
    {
        title: "给药方式对照",
        icon: 'el-icon-xmdz',
    },
    {
        title: "项目价格",
        icon: 'el-icon-xmjg',
    },
    {
        title: "挂号类别",
        icon: 'el-icon-ghlb',
    },
    {
        title: "坐诊",
        icon: 'el-icon-zzgl',
    },
    {
        title: "坐诊排班",
        icon: 'el-icon-pbgl',
    },
    {
        title: "挂号",
        icon: 'el-icon-mzgh',
    },
    {
        title: "挂号列表",
        icon: 'el-icon-yuyuejilu',
    },
    {
        title: "门诊医师",
        icon: 'el-icon-mzys',
    },
    {
        title: "病历模板",
        icon: 'el-icon-blmb',
    },
    {
        title: "门诊收费",
        icon: 'el-icon-mzsf',
    },
    {
        title: "挂账类型",
        icon: 'el-icon-guazhang',
    },
    {
        title: "收费列表",
        icon: 'el-icon-mzsf',
    },
    {
        title: "门诊护士",
        icon: 'el-icon-mzhs',
    },
]

